import { render, staticRenderFns } from "./EditAppointment.vue?vue&type=template&id=615b6073"
import script from "./EditAppointment.vue?vue&type=script&lang=js"
export * from "./EditAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports